const RESET_STATES = 'RESET_STATES';

const Clients = {
	namespaced: true,
	state: {
		clients: [],
	},
	getters: {
		clients(state) {
			return state.clients;
		},
	},
	mutations: {
		[RESET_STATES](state) {
			state.clients = [];
		},
		storeClients(state, clients) {
			state.clients = clients;
		},
		storeClient(state, client) {
			if (client.role === 'client') {
				state.clients.unshift(client);
			}
		},
		updateClient(state, client) {
			if (state.clients.length > 0) {
				state.clients = state.clients.map((current) => {
					if (current.id === client.id) {
						return Object.assign({}, current, client);
					}
					return current;
				});
			}
		},
		removeClient(state, client) {
			for (let i = 0; i < state.clients.length; i++) {
				const current = state.clients[i];
				if (current.id === client.id) {
					state.clients.splice(i, 1);
					break;
				}
			}
		},
		SOCKET_USERS_ADD(state, client) {
			if (client.role === 'client') {
				state.clients.unshift(client);
			}
		},
		SOCKET_USERS_UPDATE(state, client) {
			if (state.clients.length > 0) {
				state.clients = state.clients.map((current) => {
					if (current.id === client.id) {
						return Object.assign({}, current, client);
					}
					return current;
				});
			}
		},
		SOCKET_USERS_DELETE(state, userIds) {
			for (let i = 0; i < userIds.length; i++) {
				const userId = userIds[i];
				for (let j = 0; j < state.clients.length; j++) {
					const current = state.clients[j];
					if (current.id === userId) {
						state.clients.splice(j, 1);
						break;
					}
				}
			}
		},
	},
	actions: {
		resetStates({ commit }) {
			commit(RESET_STATES);
		},
		saveClients({ commit }, clients) {
			commit('storeClients', clients);
		},
		addClient({ commit }, user) {
			commit('storeClient', user);
		},
		removeClient({ commit }, user) {
			commit('removeClient', user);
		},
		updateClient({ commit }, user) {
			commit('updateClient', user);
		},
	},
};

export default Clients;
